<template>
    <div class="login-by-email">
        <el-form
            v-if="currentStatus === loginByEmailStatus.waiting || currentStatus === loginByEmailStatus.expired"
            ref="form"
            :model="form"
            :rules="emailRule"
        >
            <el-alert
                v-if="currentStatus === loginByEmailStatus.expired"
                :title="getVerbose(`login_${errorStatus}`)"
                :closable="false"
                type="warning"
                show-icon
            >
            </el-alert>
            <el-form-item :label="getVerbose('login_by_email')" prop="email">
                <el-input v-model="form.email" placeholder=""></el-input>
            </el-form-item>

            <el-form-item>
                <el-button
                    type="primary"
                    @click="submitRetrieveToken"
                >
                    {{ getVerbose('login_by_email_button') }}
                </el-button>

            </el-form-item>
        </el-form>

        <div
            v-else-if="currentStatus === loginByEmailStatus.emailSend"
            class="token valid"
        >
            <i class="el-icon-success"></i>
            <p>{{ getVerbose('login_LOGIN_BY_EMAIL_MAIL_SEND') }}</p>
            <el-button
                type="primary"
                @click="currentStatus = loginByEmailStatus.waiting"
            >{{ getVerbose('login_by_email_info_button') }}</el-button>
        </div>
        <div
            v-else-if="currentStatus === loginByEmailStatus.error"
            class="token invalid"
        >
            <i class="el-icon-error"></i>
            <p>{{ getVerbose(`login_${errorStatus}`) }}</p>
            <el-button
                type="primary"
                @click="currentStatus = loginByEmailStatus.waiting"
            >{{ getVerbose('login_by_email_info_button') }}</el-button>
        </div>
        <div v-else >
            <div class="ns-loading-overlay">
                <div class="ring-container">
                    <div class="lds-ring">
                        <p class="text-center">{{ getVerbose('login_by_email_loading_text') }}</p>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex';
export default {
    data: function(){
        return {
            loginByEmailStatus: {
                running: 'RUNNING',
                waiting: 'WAITING',
                expired: 'EXPIRED',
                emailSend: 'SUCCESS',
                error: 'ERROR',
            },
            currentStatus: 'WAITING',
            form: {email: ''},
            errorStatus: '',
            emailRule: {email: [
                {
                    type: 'email', required: true, message: '', trigger: 'blur'
                },
            ]},
        };
    },
    computed: {
        ...mapGetters([
            'apiRootUrl',
        ]),
        ...mapGetters('fundation', [
            'getVerbose',
        ])
    },

    mounted (){
        this.focused();
        this.emailRule.email.message = this.getVerbose('login_by_email_email_error');
    },

    methods: {
        submitRetrieveToken (){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.currentStatus = this.loginByEmailStatus.running;
                    axios.post(
                        `${this.apiRootUrl}/secure-connect/retrieve-token/`,
                        {email: this.form.email}
                    ).then(() => {
                        this.currentStatus = this.loginByEmailStatus.emailSend;
                        // this.submitLoginByEmail(response.data.token);
                    }).catch((error) => {
                        let errorKey = error.response.data._errors[0];
                        this.errorStatus = errorKey;
                        this.currentStatus = this.loginByEmailStatus.error;
                    });
                }
            });
        },

        submitLoginByEmail (token){
            this.currentStatus = this.loginByEmailStatus.running;
            axios.post(`${this.apiRootUrl}/secure-connect/login/`,
                {token: token}
            ).then((response) => {
                this.$router.push('/');
                this.$store.commit('LOGIN_USER', response.data);
                this.$store.dispatch('fetchSelfUser');
                this.$store.dispatch('loadModels').catch(() => {});
            }).catch((error) => {
                let errorKey = error.response.data._errors[0];
                this.errorStatus = errorKey;
                if(errorKey === 'TOKEN_HAS_EXPIRED'){
                    this.currentStatus = this.loginByEmailStatus.expired;
                }else{
                    this.currentStatus = this.loginByEmailStatus.error;
                }
            });
        },

        focused (){
            if(window.location.href.match(/login\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/)){
                let token = window.location.href.match(/login\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/)[1];
                this.submitLoginByEmail(token);
            }else if(window.location.href.includes('login')){
                this.currentStatus = this.loginByEmailStatus.waiting;
            }
        },
    },
};
</script>

<style lang="scss">
.login-by-email{
    min-height: 220px;
    position: relative;

    .token{
        height: 220px;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        i{
            font-size: 50px;
        }
        p{
            font-size: 15px;
            margin-top: 15px;
        }

        &.invalid i, &.invalid p{
            color: #f56c6c;
        }

        &.valid i, &.valid p{
            color: #67C23A;
        }

    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/auth/LoginByEmail.vue